<div class="dialog__kopf">
  <h2 class="dialog__ueberschrift">{{this.translate.data['CHANGEPSWD'] | translate}}</h2>
  @if (dialogRef && !forceChangPw) {
    <button type="button" class="dialog__schliessen" aria-label="Fenster schließen" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  }
</div>

<div class="dialog__inhalt">
  <div class="passwortseite">
    <div class="wer">
      <mat-icon class="wer__icon">account_circle</mat-icon>
      <span class="wer__text">
        <span class="wer__name">{{ userName }}</span>
        <span class="wer__mail">{{ userEmail }}</span>
      </span>
    </div>

    <form [formGroup]="passwordForm" novalidate>
      <div class="passwort__spalten">
        <div class="passwort__felder">
          @if (!forceChangPw) {
            <mat-form-field appearance="outline" class="mfeld" subscriptSizing="dynamic">
              <mat-label>{{this.translate.data['OLDPASSWORD'] | translate}}</mat-label>
              <input matInput [type]="passwortAltVerbergen ? 'password' : 'text'"
                     formControlName="oldPassword" autocomplete="current-password" required>
              <mat-icon matPrefix
                        class="schloss"
                        [class.schloss--offen]="!passwortAltVerbergen"
                        role="button"
                        tabindex="0"
                        (click)="passwortAltVerbergen = !passwortAltVerbergen"
                        (keydown.enter)="passwortAltVerbergen = !passwortAltVerbergen"
                        (keydown.space)="passwortAltVerbergen = !passwortAltVerbergen"
                        [attr.aria-label]="passwortAltVerbergen ? 'Passwort anzeigen' : 'Passwort verbergen'"
                        [attr.aria-pressed]="!passwortAltVerbergen">
                {{ passwortAltVerbergen ? 'lock' : 'lock_open' }}
              </mat-icon>
              @if (passwordForm.controls['oldPassword'].hasError('required')) {
                <mat-error>Bitte das aktuelle Passwort eingeben.</mat-error>
              } @else if (passwordForm.controls['oldPassword'].hasError('pattern')) {
                <mat-error>Das Passwort entspricht nicht den Passwortregeln (siehe rechts).</mat-error>
              } @else if (passwordForm.controls['oldPassword'].hasError('wrongOld')) {
                <mat-error>Altes Passwort falsch!</mat-error>
              }
            </mat-form-field>
          }

          <mat-form-field appearance="outline" class="mfeld" subscriptSizing="dynamic">
            <mat-label>{{this.translate.data['PASSWORD'] | translate}}</mat-label>
            <input matInput [type]="passwortNeuVerbergen ? 'password' : 'text'"
                   formControlName="password" autocomplete="new-password" required>
            <mat-icon matPrefix
                      class="schloss"
                      [class.schloss--offen]="!passwortNeuVerbergen"
                      role="button"
                      tabindex="0"
                      (click)="passwortNeuVerbergen = !passwortNeuVerbergen"
                      (keydown.enter)="passwortNeuVerbergen = !passwortNeuVerbergen"
                      (keydown.space)="passwortNeuVerbergen = !passwortNeuVerbergen"
                      [attr.aria-label]="passwortNeuVerbergen ? 'Passwörter anzeigen' : 'Passwörter verbergen'"
                      [attr.aria-pressed]="!passwortNeuVerbergen">
              {{ passwortNeuVerbergen ? 'lock' : 'lock_open' }}
            </mat-icon>
            @if (passwordForm.controls['password'].hasError('required')) {
              <mat-error>Bitte ein neues Passwort eingeben.</mat-error>
            } @else if (passwordForm.controls['password'].hasError('pattern')) {
              <mat-error>Das Passwort erfüllt nicht alle Regeln (siehe rechts).</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" class="mfeld" subscriptSizing="dynamic">
            <mat-label>{{this.translate.data['CONFIRMPASSWORD'] | translate}}</mat-label>
            <input matInput [type]="passwortNeuVerbergen ? 'password' : 'text'"
                   formControlName="confirmPassword" autocomplete="new-password" required>
            <mat-icon matPrefix
                      class="schloss"
                      [class.schloss--offen]="!passwortNeuVerbergen"
                      role="button"
                      tabindex="0"
                      (click)="passwortNeuVerbergen = !passwortNeuVerbergen"
                      (keydown.enter)="passwortNeuVerbergen = !passwortNeuVerbergen"
                      (keydown.space)="passwortNeuVerbergen = !passwortNeuVerbergen"
                      [attr.aria-label]="passwortNeuVerbergen ? 'Passwörter anzeigen' : 'Passwörter verbergen'"
                      [attr.aria-pressed]="!passwortNeuVerbergen">
              {{ passwortNeuVerbergen ? 'lock' : 'lock_open' }}
            </mat-icon>
            @if (passwordForm.controls['confirmPassword'].hasError('required')) {
              <mat-error>Bitte das neue Passwort wiederholen.</mat-error>
            } @else if (passwordForm.controls['confirmPassword'].hasError('pattern')) {
              <mat-error>Das Passwort erfüllt nicht alle Regeln (siehe rechts).</mat-error>
            } @else if (passwordForm.controls['confirmPassword'].hasError('mismatch')) {
              <mat-error>Die Passwörter stimmen nicht überein.</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="regeln">
          <span class="regeln__titel">Das neue Passwort braucht</span>
          <ul class="regeln__liste">
            <li>mindestens 8 Zeichen</li>
            <li>mindestens eine Ziffer</li>
            <li>einen Großbuchstaben</li>
            <li>einen Kleinbuchstaben</li>
            <li>ein Sonderzeichen &#64;$!%*#?&amp;^_-</li>
          </ul>
        </div>
      </div>

      <footer class="passwort__fuss">
        @if (!forceChangPw) {
          <button type="button" class="knopf knopf--leise" matTooltip="{{this.translate.data['TOOLTIPCLOSEADDUSERDIALOG'] | translate}}" (click)="cancel()">
            <mat-icon>close</mat-icon>
            <span>Abbrechen</span>
          </button>
        }
        <button type="button" class="knopf knopf--voll" [disabled]="passwordForm.invalid" (click)="changePassword()">
          <mat-icon>check</mat-icon>
          <span>{{this.translate.data['CHANGEPASSWORD'] | translate}}</span>
        </button>
      </footer>
    </form>
  </div>
</div>
